import _classCallCheck from "/home/node/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/node/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/node/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/node/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import { Factory } from '../Factory.js';
import { Shape } from '../Shape.js';
import { Konva } from '../Global.js';
import { getNumberValidator, getBooleanValidator } from '../Validators.js';
import { _registerNode } from '../Global.js';
export var Arc = /*#__PURE__*/function (_Shape) {
  _inherits(Arc, _Shape);
  var _super = _createSuper(Arc);
  function Arc() {
    _classCallCheck(this, Arc);
    return _super.apply(this, arguments);
  }
  _createClass(Arc, [{
    key: "_sceneFunc",
    value: function _sceneFunc(context) {
      var angle = Konva.getAngle(this.angle()),
        clockwise = this.clockwise();
      context.beginPath();
      context.arc(0, 0, this.outerRadius(), 0, angle, clockwise);
      context.arc(0, 0, this.innerRadius(), angle, 0, !clockwise);
      context.closePath();
      context.fillStrokeShape(this);
    }
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.outerRadius() * 2;
    }
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.outerRadius() * 2;
    }
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      this.outerRadius(width / 2);
    }
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      this.outerRadius(height / 2);
    }
  }, {
    key: "getSelfRect",
    value: function getSelfRect() {
      var innerRadius = this.innerRadius();
      var outerRadius = this.outerRadius();
      var clockwise = this.clockwise();
      var angle = Konva.getAngle(clockwise ? 360 - this.angle() : this.angle());
      var boundLeftRatio = Math.cos(Math.min(angle, Math.PI));
      var boundRightRatio = 1;
      var boundTopRatio = Math.sin(Math.min(Math.max(Math.PI, angle), 3 * Math.PI / 2));
      var boundBottomRatio = Math.sin(Math.min(angle, Math.PI / 2));
      var boundLeft = boundLeftRatio * (boundLeftRatio > 0 ? innerRadius : outerRadius);
      var boundRight = boundRightRatio * (boundRightRatio > 0 ? outerRadius : innerRadius);
      var boundTop = boundTopRatio * (boundTopRatio > 0 ? innerRadius : outerRadius);
      var boundBottom = boundBottomRatio * (boundBottomRatio > 0 ? outerRadius : innerRadius);
      return {
        x: boundLeft,
        y: clockwise ? -1 * boundBottom : boundTop,
        width: boundRight - boundLeft,
        height: boundBottom - boundTop
      };
    }
  }]);
  return Arc;
}(Shape);
Arc.prototype._centroid = true;
Arc.prototype.className = 'Arc';
Arc.prototype._attrsAffectingSize = ['innerRadius', 'outerRadius'];
_registerNode(Arc);
Factory.addGetterSetter(Arc, 'innerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Arc, 'outerRadius', 0, getNumberValidator());
Factory.addGetterSetter(Arc, 'angle', 0, getNumberValidator());
Factory.addGetterSetter(Arc, 'clockwise', false, getBooleanValidator());